import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isNull, uniqueId } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    prompt: {
      type: String,
      required: true
    },
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: null,
      default: null
    }
  },
  data() {
    const answer = isNull(this.value) ? "" : this.value ? "1" : "0";
    return {
      answer,
      id: uniqueId()
    };
  },
  computed: {
    valueAsBool() {
      return Boolean(_parseInt(this.answer));
    }
  },
  methods: {
    handleChange() {
      this.$emit("input", this.valueAsBool);
    }
  }
});